<template>
  <div class="member-box">
    <div class="member-list">
      <div class="tag-list-header">选择员工</div>
      <el-input placeholder="请输入内容" v-model="memberSearchInput" class="input-with-select" size="mini"
                @keyup.enter.native="loadMaterialList" @input="valueNull">
        <el-button slot="append" icon="el-icon-search" @click="loadMaterialList"></el-button>
      </el-input>
      <div class="tag-list-content">
        <el-tree
            :props="defaultProps"
            :data="tagsList"
            node-key="id"
            ref="tree"
            @check="handleCheck"
            @check-change="handleCheckChange"
            :default-expand-all="true"
            :filter-node-method="filterNode"
        >
                    <span class="custom-tree-node" slot-scope="{ node, data }">
                      <span style="margin-right: 4px">
                        <el-checkbox
                            @change="
                                   changeCheckedOrg(
                                                      node,
                                                      data
                                                    )"
                            v-model="data.checked"
                            :disabled="data.disabled"
                        ></el-checkbox>
                      </span>
                        <span>
                             <i class="arsenal_icon arsenalsitemap1" v-if="!data.isMember"></i>
                            <i class="arsenal_icon arsenaluser1" v-else></i>
                        </span>
                         <span>{{ node.label }}</span>
                     </span>
        </el-tree>
      </div>
    </div>
    <div class="member-selected">
      <div class="tag-selected-header">已选择</div>
      <div v-for="(tag,index) in memberTags" :key="index" class="checkTags">
        <div class="tagName">
          <i class="arsenal_icon arsenalsitemap1" v-if="!tag.isMember"></i>
          <i class="arsenal_icon arsenaluser1" v-else></i>
          {{ tag.name }}
        </div>
        <i class="el-icon-close" @click="deleteTag(tag.id)"></i>
      </div>
      <div class="tag-selected-content">
      </div>
    </div>
  </div>
</template>

<script>


import {showParent} from "@/assets/js/getChildrenLeng";

export default {
  name: "staffDialog",
  data() {
    return {
      defaultProps: {
        label: "name",
        children: "children",
      },
      tagsList: [],
      tags: [],
      memberSearchInput: '',
      valueNull: '',
      memberIds: [],
      departmentStaffNum: 0,
      memberNum: 0,
      checkMemberIds: [],
      originMember: [],
      testIds: [],
      memberTags: []
    }
  },
  props: {
    maxNum: {
      type: Number,
      default() {
        return 0
      }
    }
  },
  methods: {
    filterNode(value, data) {
      if (!value) return true;
      return data.name.indexOf(value) !== -1;
    },
    getMemberTags() {
      let url = '/scrm-api/we-work/member'
      this.$http.get(url).then(res => {
        console.log(res)
        if (res.status === 200) {
          this.tagsList = res.data
          this.tagsList.forEach(item => {
            this.$set(item, 'checked', false)
            this.setChecked(item.children)
          })
          console.log(this.tagsList)
          this.getTagList(this.memberIds, this.tagsList[0])
        }
      })

    },
    changeOrgChildrenProperties(list, fun) {
      if (list == null || list.length == 0 || fun == null) {
        return;
      }
      list.forEach(item => {
        fun(item);
        this.changeOrgChildrenProperties(item.children, fun);
      });

    },
    checkOrgChildrenProperties(list, fun) {
      if (list == null || list.length == 0 || fun == null) {
        return;
      }
      list.forEach(item => {
        fun(item);
        this.checkOrgChildrenProperties(item.children, fun);
      });

    },
    getdepatmentMember(data, memberTags, id) {
      var children = [];
      if (data) {
        if (id.indexOf(data.id) !== -1) {
          memberTags.push(data)
        }
        if (data.children) {
          children = data.children
        }
      }
      for (var child of children) {
        //每遍历一个子元素，就输出元素名
        this.getdepatmentMember(child, memberTags, id);
      }
      return memberTags
    },
    getTagList(id, memberList) {
      console.log(this.getdepatmentMember(memberList, [], id))
      let tags = this.getdepatmentMember(memberList, [], id)
      let obj = {};
      let peon = tags.reduce((cur, next) => {
        obj[next.id] ? "" : obj[next.id] = true && cur.push(next);
        return cur;
      }, [])
      this.tags = peon
    },
    initShowOrTree(handleIdArr, isChecked, type) {
      console.log(handleIdArr)
      const formOrgTree = (arr, handleIdArr, isChecked) => {
        if (type == "close") {
          arr.forEach((item) => {
            if (handleIdArr.indexOf(item.id) != -1) {
              item.checked = isChecked;
              if (item.children) {
                formOrgTree(item.children, handleIdArr, isChecked);
              }
            } else {
              if (item.children) {
                formOrgTree(item.children, handleIdArr, isChecked);
              }
            }
          });
        } else {
          arr.forEach((item) => {
            if (handleIdArr.indexOf(item.id) != -1) {
              item.checked = isChecked;
              if (item.children) {
                formOrgTree(item.children, handleIdArr, isChecked);
              }
            } else {
              item.checked = !isChecked;
              if (item.children) {
                formOrgTree(item.children, handleIdArr, isChecked);
              }
            }
          });
        }
        return arr;
      };
      this.tagsList = [
        ...formOrgTree(this.tagsList, handleIdArr, isChecked),
      ];
      showParent(handleIdArr, 0)
    },
    setChecked(value) {
      if (value !== null) {
        value.forEach(item => {
          this.$set(item, 'checked', false)
          this.setChecked(item.children)
        })
      } else
        return value
    },
    changeCheckedOrg(node, data) {
      this.memberNum = 0
      this.testIds = []
      this.changeOrgChildrenProperties(data.children, (item) => {
        if (item.isMember) {
          this.memberNum += 1
          this.testIds.push(item.id)
        }
      })
      function getArrEqual(arr1, arr2) {
        let newArr = [];
        for (let i = 0; i < arr2.length; i++) {
          for (let j = 0; j < arr1.length; j++) {
            if (arr1[j]=== arr2[i]) {
              newArr.push(arr1[j]);
            }
          }
        }
        return newArr.length;
      }
      let ids = {};
      let memberids = this.testIds.reduce((cur, next) => {
        ids[next] ? "" : ids[next] = true && cur.push(next);
        return cur;
      }, [])

      this.testIds=memberids
      console.log(this.testIds)
      let length = getArrEqual(this.testIds, this.originMember)
      let bool = false
      console.log(length)
      console.log(this.maxNum)
      console.log(this.testIds.length)
      console.log(this.originMember)
      console.log( this.testIds.length-length > this.maxNum-this.originMember)
      if ( this.testIds.length-length > this.maxNum-this.originMember.length ) {
        bool = true
      }
      if (bool) {
        this.$message({
          message: '组织架构下人数超出剩余可选数量',
          type: 'warning',
          duration: 2000
        })
        data.checked = false
        return
      }
      console.log(this.maxNum)
      console.log(data.id)
      console.log(this.originMember.indexOf(data.id))
      if (this.originMember.indexOf(data.id) === -1 && data.isMember) {
        if (this.originMember.length >= this.maxNum) {
          this.$message({
            message: '当前账号只可选择' + this.maxNum + '名员工',
            type: 'warning',
            duration: 2000
          })
          data.checked = false
          return
        }
      }
      this.changeOrgChildrenProperties(data.children, (item) => item.checked = data.checked);
      if (data.checked) {
        this.changeOrgChildrenProperties([data], (item) => {
          this.tags.unshift(item)
        });
      } else {
        this.changeOrgChildrenProperties([data], (item) => {
          this.tags.forEach((cell, cellIndex) => {
            if (cell.id == item.id) {
              this.tags.splice(cellIndex, 1);
            }
          });
        });
      }
      this.tags = [...this.tags];
      let obj = {};
      let peon = this.tags.reduce((cur, next) => {
        obj[next.id] ? "" : obj[next.id] = true && cur.push(next);
        return cur;
      }, [])
      this.tags = peon
      console.log("tags", this.tags);
      console.log(showParent(this.tags, 0))

    },
    handleCheckChange(data, checked, indeterminate) {
      console.log(data)
      this.departmentStaffNum = 0
      this.memberNum = 0
      this.testIds = []
      this.changeOrgChildrenProperties(data.children, (item) => {
        if (item.isMember) {
          this.memberNum += 1
          this.testIds.push(item.id)
        }
      })
      console.log(this.memberNum)
      let bool = false

      function getArrEqual(arr1, arr2) {
        let newArr = [];
        for (let i = 0; i < arr2.length; i++) {
          for (let j = 0; j < arr1.length; j++) {
            if (arr1[j] === arr2[i]) {
              newArr.push(arr1[j]);
            }
          }
        }
        return newArr.length;
      }

      let length = getArrEqual(this.testIds, this.originMember)
      console.log(getArrEqual(this.testIds, this.originMember));
      console.log(this.maxNum - this.originMember.length - length)
      if (checked) {
        if (this.memberNum - length > this.maxNum - this.originMember.length) {
          bool = true
        }
        if (bool) {
          this.$message({
            message: '组织架构下人数超出剩余可选数量',
            type: 'warning',
            duration: 2000
          })
          this.$refs.tree.setCheckedKeys(this.memberIds)
          return
        }
        console.log(this.maxNum)
        console.log(data.id)
        console.log(this.originMember.indexOf(data.id))
        if (this.originMember.indexOf(data.id) === -1 && data.isMember) {
          if (this.originMember.length >= this.maxNum) {
            this.$refs.tree.setCheckedKeys(this.memberIds)
            this.$message({
              message: '当前账号只可选择' + this.maxNum + '名员工',
              type: 'warning',
              duration: 2000
            })
            return

          }
        }
      }

      let ids = this.$refs.tree.getCheckedKeys()
      let node = this.$refs.tree.getCheckedNodes()
      this.memberIds = ids
      this.tags = node

    },
    handleCheck(data, node) {
      console.log(data, node)
    },
    deleteTag(id) {
      this.initShowOrTree([id], false, "close");
      for (let i = 0; i < this.tags.length; i++) {
        if (this.tags[i].id === id) {
          this.tags.splice(i, 1)
        }
      }
      console.log(this.tags)
      /* let ids = []
       for (let i = 0; i < this.tags.length; i++) {
         ids.push(this.tags[i].id)
       }
       this.$nextTick(() => {
         this.$refs.tree.setCheckedKeys(ids)
       })*/
    },
    loadMaterialList() {
    }
  },
  mounted() {
    this.getMemberTags()
  },
  watch: {
    tags: {
      handler(value) {
        console.log(value)
        this.checkMemberIds = []
        this.originMember = []
        this.memberTags = []
        /* console.log(value)
         value.forEach(item=>{
           if (item.isMember){
             this.memberIds.push(item.id)
           }
         })*/
        for (let i = 0; i < value.length; i++) {
          if (value[i].checked&&value[i].isMember) {
            this.memberTags.unshift(value[i])
          }
        }
        console.log(this.memberTags)
        let checkMemberIds = [];
        let originMember = []
        for (let i = 0; i < value.length; i++) {
          checkMemberIds.push(value[i].id)
          if (value[i].isMember) {
            originMember.push(value[i].id)
          }
          this.checkOrgChildrenProperties(value[i].children, (item) => {
            checkMemberIds.push(item.id)
            if (item.isMember) {
              originMember.push(item.id)
            }
          })
        }
        for (var i = 0; i < checkMemberIds.length; i++) {
          if (this.checkMemberIds.indexOf(checkMemberIds[i]) === -1) {
            this.checkMemberIds.push(checkMemberIds[i])
          }
        }
        for (var i = 0; i < originMember.length; i++) {
          if (this.originMember.indexOf(originMember[i]) === -1) {
            this.originMember.push(originMember[i])
          }
        }
        console.log('originMember', this.originMember)
        console.log('checkMemberIds', this.checkMemberIds)
      },
      deep: true,
      immediate:true
    },
    memberSearchInput(val){
      this.$refs.tree.filter(val);
    }
  }
}
</script>

<style lang="less">
.member-box {
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  .member-list {
    width: 48%;
    border: 1px solid rgb(233, 233, 233);
    border-radius: 5px;
    padding: 10px;
    height: 400px;
    overflow-x: hidden;
    overflow-y: auto;
    margin-right: 10px;

    .tag-list-header {
      padding-bottom: 5px;
      border-bottom: 1px solid rgb(233, 233, 233);
    }

    .tag-list-content {
      padding: 10px 0px;

      .custom-tree-node {
        display: flex;
        align-items: center;
        justify-content: flex-start;

        i {
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 14px;
          margin-right: 8px;
        }

        .arsenalfolder-open-fill {
          font-size: 18px;
        }

      }

      .el-checkbox__input.is-indeterminate .el-checkbox__inner {
        background-color: white !important;
        border-color: white !important;
      }
    }
  }

  .member-selected {
    width: 49%;
    border: 1px solid rgb(233, 233, 233);
    border-radius: 5px;
    padding: 10px;
    height: 400px;
    overflow-x: hidden;
    overflow-y: auto;

    .tag-selected-header {
      padding-bottom: 5px;
      border-bottom: 1px solid rgb(233, 233, 233);
    }

    .tag-selected-content {
      padding: 10px 0px;
    }

    .checkTags {
      display: flex;
      justify-content: space-between;
      padding: 6px 0;
      align-items: center;

      .tagName {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;

        i {
          font-size: 14px;
        }
      }

      .el-icon-close {
        cursor: pointer;
        color: red;
      }
    }
  }

  .buttonCheck {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin: 0 10px;

    .el-button {
      margin: 20px 0;
    }
  }
}
</style>